import React, { useState } from 'react'
import { Button, Icon, Modal } from 'semantic-ui-react'
import Proptypes from 'prop-types'
import styles from './device-view.module.css'
import { primaryColor, secondaryColor } from '../../../constants'
import IntelMsg from '../../ItelMsg'

const DeviceActions = ({ onBackClick }) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  return (
    <>
      <div className={styles.actions}>
        <Button
          style={{ background: primaryColor, color: 'white' }}
          icon
          labelPosition="left"
          onClick={() => onBackClick()}
        >
          <Icon name="arrow left" />
          <IntelMsg id="back" />
        </Button>
        <div>
          <Button
            style={{ background: secondaryColor, color: 'white' }}
            icon
            color="facebook"
            labelPosition="left"
          >
            <Icon name="edit" />
            <IntelMsg id="edit" />
          </Button>
          <Button
            icon
            color="red"
            labelPosition="left"
            onClick={() => setOpenDeleteModal(true)}
          >
            <Icon name="trash" />
            <IntelMsg id="delete" />
          </Button>
        </div>
      </div>
      <DeleteModal
        open={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
      />
    </>
  )
}
DeviceActions.propTypes = {
  onBackClick: Proptypes.func.isRequired,
}

const DeleteModal = ({ open, setOpenDeleteModal }) => (
  <Modal
    size="small"
    open={open}
    style={{ position: 'relative', height: 'auto' }}
  >
    <Modal.Header className={styles.header}>Delete Device</Modal.Header>
    <Modal.Content image style={{ alignItems: 'center' }}>
      <Icon name="warning circle" size="huge" />
      <p style={{ fontSize: 'x-large' }}>
        <IntelMsg id="deleteMsg" />
      </p>
    </Modal.Content>
    <Modal.Actions>
      <Button negative onClick={() => setOpenDeleteModal(false)}>
        <IntelMsg id="yes" />
      </Button>
      <Button
        className={styles.positiveStatus}
        onClick={() => setOpenDeleteModal(false)}
      >
        <IntelMsg id="no" />
      </Button>
    </Modal.Actions>
  </Modal>
)

DeleteModal.propTypes = {
  open: Proptypes.bool.isRequired,
  setOpenDeleteModal: Proptypes.func.isRequired,
}
export default DeviceActions
